function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "text-/-text_underline",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.000000, 4.000000)",
  fill: "#555555"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.00892857,13.862 C7.6875,13.862 8.97321429,13.4155714 9.88392857,12.5584286 C10.7946429,11.6834286 11.2589286,10.4155714 11.2589286,8.75485714 L11.2589286,0.862 L9.3125,0.862 L9.3125,8.79057143 C9.3125,9.93342857 9.04464286,10.7727143 8.52678571,11.3262857 C7.99107143,11.8798571 7.15178571,12.1655714 6.00892857,12.1655714 C4.84821429,12.1655714 4.00892857,11.8798571 3.47321429,11.3262857 C2.9375,10.7727143 2.6875,9.93342857 2.6875,8.79057143 L2.6875,0.862 L0.741071429,0.862 L0.741071429,8.75485714 C0.741071429,10.4155714 1.20535714,11.6834286 2.13392857,12.5762857 C3.02678571,13.4334286 4.3125,13.862 6.00892857,13.862 Z",
  id: "U",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 15,
  width: 12,
  height: 1.5
})));

function SvgTextUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "text / text_underline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextUnderline);
export default __webpack_public_path__ + "static/media/text_underline.078cb4e4.svg";
export { ForwardRef as ReactComponent };